module.exports = __webpack_public_path__ + "static/media/font-case.96e6aec6.svg";